/* eslint-disable lingui/no-unlocalized-strings */
// Chrome (NavBar/Footer) is owned by HomeLayout — do not render here.
import { t } from "@lingui/macro";
import { Card } from "@reactive-resume/ui";
import { Helmet } from "react-helmet-async";

export const SecurityResearchersPage = () => (
  <div className="min-h-screen delay-100 duration-500 animate-in fade-in slide-in-from-bottom-4 fill-mode-both">
    <Helmet>
      <title>{t`Security researchers — Apply Edge`}</title>
      <meta
        content={t`Researchers who have helped make Apply Edge more secure.`}
        name="description"
      />
      <meta content="/og/default.png" property="og:image" />
    </Helmet>

    <section className="border-b border-border">
      <div className="mx-auto max-w-[960px] px-6 py-20">
        <span className="text-xs font-medium text-muted-foreground">Security</span>
        <h1 className="mt-3 font-serif text-[44px] font-semibold leading-[1.04] tracking-tight text-foreground sm:text-[60px]">
          Hall of fame
        </h1>
        <p className="mt-5 max-w-2xl text-[15.5px] leading-[1.7] text-muted-foreground">
          Researchers who&apos;ve helped make Apply Edge more secure. Thank you.
        </p>
      </div>
    </section>

    <section>
      <div className="mx-auto max-w-[960px] px-6 py-16">
        <Card className="rounded-2xl border border-border bg-surface p-8 shadow-sm transition-all duration-150 ease-out hover:-translate-y-[1px] hover:shadow-md">
          <p className="text-[15px] leading-[1.7] text-foreground">
            No researchers listed yet. Be the first — email security@apply-edge.com.
          </p>
          <p className="mt-5 border-t border-border pt-5 text-[12.5px] leading-[1.6] text-muted-foreground">
            We add names within 30 days of confirmed reports, with researcher consent.
          </p>
        </Card>
      </div>
    </section>
  </div>
);
